import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CashIcon, Image, NullFundIcon, SimpleHint, Text, WarningIcon } from '@common-fe/common-fe';

import NullIconURL from '@/assets/placeholders/FundNullIcon.svg';

import { InvestmentHolding, InvestmentHoldingStatus, InvestmentPending } from '../investments.types';
const CASH_KEY = 'CASH';

const DEFAULT_SIZE = '32px';
type IconObject = Partial<InvestmentPending | InvestmentHolding> & {
  isGreyMode?: boolean;
  isNullMode?: boolean;
  message?: string;
  testId?: string;
  size?: string;
};
export default () => {
  const { t } = useTranslation();
  const handleGetIcon = useCallback(
    (item: IconObject) => {
      const testId = item.testId;
      let icon: React.ReactNode = (
        <NullFundIcon
          data-testid={testId ? `${testId}_null-fund-icon` : 'null-fund-icon'}
          width={item.size || DEFAULT_SIZE}
          height={item.size || DEFAULT_SIZE}
          style={{
            minWidth: item.size || DEFAULT_SIZE,
            height: item.size || DEFAULT_SIZE,
            opacity: item.isGreyMode ? 0.2 : 1,
          }}
        />
      );
      if (item?.type === CASH_KEY) {
        icon = <CashIcon data-testid={testId ? `${testId}_cash-icon` : 'cash-icon'} />;
      } else if (item?.status === InvestmentHoldingStatus.Inactive) {
        icon = (
          <Box align="center" justify="center" style={{ position: 'relative' }}>
            {item?.image ? (
              <Image
                alt="stock image"
                data-testid={testId ? `${testId}_${item.symbol}` : `fund-icon_${item.symbol}`}
                src={item.image}
                fallback={NullIconURL}
                style={{ width: item.size || DEFAULT_SIZE, height: item.size || DEFAULT_SIZE, opacity: 0.03 }}
              />
            ) : (
              <NullFundIcon
                data-testid={testId ? `${testId}_null-fund-icon` : 'null-fund-icon'}
                style={{ width: item.size || DEFAULT_SIZE, height: item.size || DEFAULT_SIZE, opacity: 0.03 }}
              />
            )}
            <Box style={{ position: 'absolute' }}>
              <SimpleHint
                content={
                  <Text data-testid="warning-text" size="small" weight={500}>
                    {item.message ||
                      t(
                        "The holding is delisted as it no longer meets the requirements for stock exchange reporting or goes private. Don't worry, you can still sell it."
                      )}
                  </Text>
                }
              >
                <WarningIcon data-testid="warning-icon" size={item.size || DEFAULT_SIZE} />
              </SimpleHint>
              {/* <Hint
                hintWidth={250}
                contentStyles={{
                  zIndex: 10000,
                  position: 'relative',
                }}
                hintElement={}
              >
               
              </Hint> */}
            </Box>
          </Box>
        );
      } else if (item.image) {
        icon = (
          <Image
            alt="stock image"
            data-testid={testId ? `${testId}_fund-icon` : 'fund-icon'}
            src={item.image}
            fallback={NullIconURL}
            style={{
              width: item.size || DEFAULT_SIZE,
              height: item.size || DEFAULT_SIZE,
              opacity: item?.isGreyMode ? 0.2 : 1,
            }}
          />
        );
      }

      return icon;
    },
    [t]
  );
  return handleGetIcon;
};
